// src/App.js
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import CompanyIntro from "./components/CompanyIntro";
import Services from "./components/Services";
import WhyUs from "./components/WhyUs";
import Architecture from "./components/Architecture";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ThankYou from "./pages/ThankYou";

import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <CompanyIntro />
              <Services />
              <WhyUs />
              <Architecture />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route path="/thankyou" element={<ThankYou />} />
      </Routes>
    </>
  );
}

export default App;
